import React from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import Button from '@mui/material/Button'



const styles = {
  root: css`
    width: 100%;
    padding: 15px 30px;
    box-shadow: 0px 0 5px -1px #888;
  `,
  button: css`
    width: 100%;
  `
}


const FilterFooter = props => {
  const {onClick} = props


  return (
    <div css={styles.root}>
      <Button onClick={onClick} css={styles.button} disableElevation>
        Apply
      </Button>
    </div>
  )
}


export default FilterFooter